import GlobalState, { watchVideo } from '../../../../stores/GlobalState'
import Slider from 'react-slick'
import { Fragment, useEffect, useRef, useState } from 'react'
import classNames from 'classnames'
import { observer } from 'mobx-react'
import { ReactComponent as ArrowLeft } from '../../../../assets/arrow-left.svg'
import { ReactComponent as Play } from '../../../../assets/Rectangle 6.svg'
import { ReactComponent as Pause } from '../../../../assets/Rectangle 7.svg'
import Shop from '../Shop'
import './index.scss'
import ContentState from '../../../../stores/ContentState'

const Terminals = observer(() => {
  const content = ContentState
  const [current, setCurrent] = useState(0)
  const slider = useRef<any>(null)

  const [width, setWidth] = useState(window.innerWidth)

  useEffect(() => {
    setWidth(window.innerWidth)
    window.addEventListener('resize', () => setWidth(window.innerWidth))
  }, [])
  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 300,
    variableWidth: width > 1024 ? true : false,
    slidesToShow: 1,
    slidesToScroll: 1,
    appendArrows: '.we-block__terminals-btns',
  }

  const getSlides = () => {
    const withV: any = [],
      withIm: any = [],
      noMedia: any = []
    content.about?.we.terminals.slides?.forEach((s: any, i: number) => {
      if (!s.image && !s.video) noMedia.push(i)
      if (!s.image && s.video) withV.push(i)
      if (s.image && !s.video) withIm.push(i)
    })

    const res: any = []
    let arr: any = []
    content.about?.we.terminals.slides?.forEach((s: any, i: number) => {
      withV.forEach((m: number) => {
        if (m == i) {
          res.push([s])
        }
      })
      withIm.forEach((m: number) => {
        if (m == i) {
          res.push([s])
        }
      })

      noMedia.forEach((m: number) => {
        if (m == i) {
          arr.push(s)
        }
        if (arr.length == 2) {
          res.push(arr)
          arr = []
        }
      })
    })
    return res
  }

  if (!content.about?.we.terminals) return <></>

  return (
    <div className="we-block__terminals">
      <div className="we-block__terminals-container">
        <div className="we-block__terminals-top">
          <div
            className="we-block__terminals-maintitle"
            dangerouslySetInnerHTML={{
              __html: content.about.we.terminals.title,
            }}
          ></div>
          <div className="we-block__terminals-btns">
            <div
              className={classNames('we-block__terminals-btn back')}
              onClick={() => slider.current?.slickPrev()}
            >
              <ArrowLeft />
            </div>
            <div
              className={classNames('we-block__terminals-btn next')}
              onClick={() => slider.current?.slickNext()}
            >
              <ArrowLeft />
            </div>
          </div>
        </div>
        {width > 768 ? (
          <div className="we-block__terminals-slider">
            <Slider
              {...settings}
              ref={slider}
              afterChange={(index: number) => setCurrent(index)}
            >
              {content.about.we.terminals.slides?.map((s: any, i: number) => (
                <div
                  className={classNames(
                    'we-block__terminals-slide',

                    !i && 'one',
                    i + 1 == content.about?.we.terminals.slides.length &&
                      'last',
                  )}
                  key={i}
                >
                  {s.video && (
                    <TerminalVideo src={s.video} poster={s.poster || ''} />
                  )}
                  {s.image && (
                    <div className="we-block__terminals-video">
                      <img src={s.image} />
                    </div>
                  )}
                  <div className="we-block__terminals-col">
                    <div className="we-block__terminals-title">{s.title}</div>
                    <ul className="we-block__terminals-list">
                      {s.text.split(';').map((st: any, id: number) =>
                        st.trim().length ? (
                          <>
                            {st.includes('.') ? (
                              <div
                                className="we-block__terminals-text"
                                key={id}
                                dangerouslySetInnerHTML={{
                                  __html: st,
                                }}
                              ></div>
                            ) : (
                              <li
                                className="we-block__terminals-text"
                                key={id}
                                dangerouslySetInnerHTML={{
                                  __html: st,
                                }}
                              ></li>
                            )}
                          </>
                        ) : (
                          <Fragment key={id}></Fragment>
                        ),
                      )}
                    </ul>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        ) : (
          <div className="we-block__terminals-slider">
            <Slider
              {...settings}
              ref={slider}
              afterChange={(index: number) => setCurrent(index)}
            >
              {getSlides().map((s: any, i: number) => (
                <div
                  className={classNames(
                    'we-block__terminals-slide',

                    !i && 'one',
                    i + 1 == content.about?.we.terminals.slides.length &&
                      'last',
                  )}
                  key={i}
                >
                  {s.length == 1 && s[0].video && (
                    <TerminalVideo src={s[0].video} poster={s[0].poster} />
                  )}
                  {s.length == 1 && s[0].image && (
                    <div className="we-block__terminals-video">
                      <img src={s[0].image} />
                    </div>
                  )}
                  <>
                    {s.length > 1 ? (
                      <>
                        {s.map((si: any, idx: number) => (
                          <div
                            className={classNames(
                              'we-block__terminals-col',
                              !idx && 'col-first',
                            )}
                            key={idx}
                          >
                            <div className="we-block__terminals-title">
                              {si.title}
                            </div>
                            <ul className="we-block__terminals-list">
                              {si.text
                                .split(';')
                                .map((st: string, id: number) =>
                                  st.trim().length ? (
                                    <>
                                      {st.includes('.') ? (
                                        <div
                                          className="we-block__terminals-text"
                                          key={id}
                                          dangerouslySetInnerHTML={{
                                            __html: st,
                                          }}
                                        ></div>
                                      ) : (
                                        <li
                                          className="we-block__terminals-text"
                                          key={id}
                                          dangerouslySetInnerHTML={{
                                            __html: st,
                                          }}
                                        ></li>
                                      )}
                                    </>
                                  ) : (
                                    <Fragment key={id}></Fragment>
                                  ),
                                )}
                            </ul>
                          </div>
                        ))}
                      </>
                    ) : (
                      <>
                        <div className="we-block__terminals-col">
                          <div className="we-block__terminals-title">
                            {s[0].title}
                          </div>
                          <ul className="we-block__terminals-list">
                            {s[0].text
                              .split(';')
                              .map((st: string, id: number) =>
                                st.trim().length ? (
                                  <>
                                    {st.includes('.') ? (
                                      <div
                                        className="we-block__terminals-text"
                                        key={id}
                                        dangerouslySetInnerHTML={{
                                          __html: st,
                                        }}
                                      ></div>
                                    ) : (
                                      <li
                                        className="we-block__terminals-text"
                                        key={id}
                                        dangerouslySetInnerHTML={{
                                          __html: st,
                                        }}
                                      ></li>
                                    )}
                                  </>
                                ) : (
                                  <Fragment key={id}></Fragment>
                                ),
                              )}
                          </ul>
                        </div>
                      </>
                    )}
                  </>
                </div>
              ))}
            </Slider>
          </div>
        )}
        {width <= 768 && (
          <div className="we-block__terminals-btns">
            <div
              className={classNames('we-block__terminals-btn back')}
              onClick={() => slider.current?.slickPrev()}
            >
              <ArrowLeft />
            </div>
            <div
              className={classNames('we-block__terminals-btn next')}
              onClick={() => slider.current?.slickNext()}
            >
              <ArrowLeft />
            </div>
          </div>
        )}
      </div>
    </div>
  )
})

export default Terminals

const TerminalVideo = observer(
  ({ src, poster = '' }: { src: string; poster?: string | undefined }) => {
    const [post, setPost] = useState<any>(null)
    const video = useRef<any>(null)
    const [isPlay, setPlay] = useState(false)
    const playVideo = () => {
      if (!video.current) return
      if (video.current.paused) {
        video.current.play()
        setPlay(true)
      } else {
        video.current.pause()
        setPlay(false)
      }
    }

    useEffect(() => {
      setTimeout(() => {
        setPost(poster!)
      }, 300)
    }, [])

    useEffect(() => {
      if (GlobalState.video.show) {
        setPlay(true)
      } else setPlay(false)
    }, [GlobalState.video])
    return (
      <div className="we-block__terminals-video">
        {post && (
          <video
            ref={video}
            poster={post}
            src={src}
            autoPlay={false}
            preload={'preload'}
            controls={false}
          >
            <source src={src} type="video/mp4"></source>
          </video>
        )}
        <div
          className={classNames('we-block__terminals-play', isPlay && 'hide')}
          onClick={() => {
            ;/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
              ? playVideo()
              : watchVideo(src, poster!)
          }}
        >
          {!isPlay ? <Play /> : <Pause />}
        </div>
      </div>
    )
  },
)
